// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-empty {\n  background-color: #f7f7f7;\n  width: 61px;\n  height: 38px;\n}\n.image-slot {\n  padding-left: 25px;\n  padding-top: 11px;\n}\n.custom-cas-goods-list .el-input.is-disabled .el-input__inner {\n  background-color: #ffffff;\n  color: #001528;\n  border: 0px;\n  padding: 0px;\n  height: 25px;\n}", ""]);
// Exports
module.exports = exports;
